import Phones from "./Phones";

export default Phones;
